import { render, staticRenderFns } from "./AdminUnmanagedReportEntity.vue?vue&type=template&id=5a895230&scoped=true&"
import script from "./AdminUnmanagedReportEntity.vue?vue&type=script&lang=js&"
export * from "./AdminUnmanagedReportEntity.vue?vue&type=script&lang=js&"
import style0 from "./AdminUnmanagedReportEntity.vue?vue&type=style&index=0&id=5a895230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a895230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a895230')) {
      api.createRecord('5a895230', component.options)
    } else {
      api.reload('5a895230', component.options)
    }
    module.hot.accept("./AdminUnmanagedReportEntity.vue?vue&type=template&id=5a895230&scoped=true&", function () {
      api.rerender('5a895230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminUnmanagedReportEntity.vue"
export default component.exports